// Template261: Bélgica - Aeropuertos (Airports.jsx)
// Header, intro, two airport boxes (title, body, subsections with h4 + ul), optional sabiasQue per box (componente SabiasQue).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template261 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#D4A017";
	const airports = Array.isArray(page?.data?.airports)
		? page.data.airports
		: [];
	const sabiasQueList = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const boxStyle = {
		backgroundColor: "#f9ebc8",
		border: "3px solid #D4A017",
		borderRadius: "16px",
		padding: "16px",
		position: "relative",
	};

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "8px",
		marginTop: 0,
		color: "#8b6914",
	};

	const estiloH4 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 12,
		fontWeight: 600,
		margin: 0,
		color: "#333",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const ulStyle = { paddingLeft: "18px", margin: 0, fontSize: 13 };

	const getSabiasQueForIndex = (index) =>
		sabiasQueList.find((s) => s.index === index);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 2,
					position: "relative",
					marginTop: isSmallScreen ? 2 : 0,
				}}
			>
				{airports.map((airport, idx) => (
					<Box key={idx} data-block-id={`text-${idx + 3}`} sx={boxStyle}>
						{airport.title && (
							<Box component="h3" sx={estiloH3}>
								{airport.title}
							</Box>
						)}
						{airport.body && (
							<Box component="p" sx={{ ...estiloP, fontSize: 13 }}>
								{airport.body}
							</Box>
						)}
						{Array.isArray(airport.subsections) &&
							airport.subsections.map((sub, subIdx) => (
								<Box
									key={subIdx}
									sx={{ fontSize: 13, marginTop: subIdx === 0 ? 1.5 : 1 }}
								>
									{sub.title && (
										<Box component="h4" sx={estiloH4}>
											{sub.title}
										</Box>
									)}
									{sub.itemsHtml && (
										<Box
											component="ul"
											sx={ulStyle}
											dangerouslySetInnerHTML={{ __html: sub.itemsHtml }}
										/>
									)}
								</Box>
							))}
						{getSabiasQueForIndex(idx) && (
							<Box
								sx={{
									position: "absolute",
									bottom: idx === 0 ? -20 : -20,
									right: idx === 0 ? "33%" : "50%",
								}}
							>
								<SabiasQue
									icono={getSabiasQueForIndex(idx).icono}
									texto={getSabiasQueForIndex(idx).texto}
								/>
							</Box>
						)}
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template261.thumbnail = "/images/template-1.png";
export default Template261;
